import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_STORAGE_KEY = "ll_session_token";

export const getStoredToken = () => {
  try { return localStorage.getItem(TOKEN_STORAGE_KEY) || ""; } catch { return ""; }
};
export const setStoredToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_STORAGE_KEY, t);
    else localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch { /* ignore */ }
};
export const clearStoredToken = () => setStoredToken("");

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Authorization: Bearer <token> on every request when we have one.
// This is the fallback path used on custom domains / production, where the
// HttpOnly `session_token` cookie may be blocked as third-party by some
// browsers (Safari ITP, incognito, custom subdomain crossing to
// *.emergent.host, etc). It's belt-and-braces alongside the cookie.
api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Helpers
export const apiGet = (path, params) => api.get(path, { params }).then((r) => r.data);
export const apiPost = (path, body) => api.post(path, body).then((r) => r.data);
export const apiPut = (path, body) => api.put(path, body).then((r) => r.data);
export const apiPatch = (path, body) => api.patch(path, body).then((r) => r.data);
export const apiDelete = (path) => api.delete(path).then((r) => r.data);
